import styles from './CardFamilyMember.module.css';
import iconOptions from '../../../../assets/img/icons/icon-menu-options.png';
import { Link } from 'react-router-dom';
import { utils } from '../../../../utils';
import config from '../../../../../config';
import { useState, useRef, useEffect } from 'react';

interface CardFamilyMemberProps {
    it: any;
    typeRelationship: string;
    enableButtons: boolean;
    data: any;
    onDelFamilyModal: (family: any) => void;
    getFullname: (family: any) => string;
    onAppointmentReserve: () => void;
}

export const CardFamilyMember = ({ it, data, enableButtons, typeRelationship, onDelFamilyModal, getFullname, onAppointmentReserve }: CardFamilyMemberProps) => {
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLImageElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && 
                buttonRef.current && 
                !menuRef.current.contains(event.target as Node) && 
                !buttonRef.current.contains(event.target as Node)) {
                setShowMenu(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const onCloseMenu = () => {
        setShowMenu(false);
    }

    const onOpenMenu = () => {
        setShowMenu(true);
    }

    const onDelFamily = () => {
        onDelFamilyModal(it);
        onCloseMenu();
    }

    return (
        <div className={styles.card}>
            <div className={styles.card__options}>
                <img 
                    ref={buttonRef}
                    src={iconOptions} 
                    className={styles.options__icon} 
                    onClick={onOpenMenu} 
                />

                {showMenu && (
                    <div ref={menuRef} className={`${styles.options__menu}`}>
                        <div className={`${styles.options__item} ${styles.options__item_delete}`} onClick={onDelFamily}>
                            Eliminar
                        </div>
                        <div className={`${styles.options__item} ${styles.options__item_cancel}`} onClick={onCloseMenu}>
                            Cancelar
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.card__header}>
                <div className={styles.card__avatar}>
                    <img
                        alt="Avatar"
                        className={styles.avatar__img}
                        src={data.image_store_id ? utils.getImagenBase64(data.image_store_id) : 'https://ng-backend.indisa.cl/app/uploads/2022/08/Avatar-hombre-1.jpg'}

                    />
                </div>
                <h3 className={styles.card__name}>{getFullname(data)}</h3>
            </div>

            <div className={styles.card__info}>
                <div className={styles.info__item}>
                    <p className={styles.info__label}>Relación</p>
                    <p className={styles.info__value}>{typeRelationship ? typeRelationship : 'N/A'}</p>
                </div>
                <div className={styles.info__item}>
                    <p className={styles.info__label}>{data.document_type.name}</p>
                    <p className={styles.info__value}>{data.document_number}</p>
                </div>
                <div className={styles.info__item}>
                    <p className={styles.info__label}>Email</p>
                    <p className={styles.info__value}>{data.email}</p>
                </div>
                <div className={styles.info__item}>
                    <p className={styles.info__label}>Teléfono</p>
                    <p className={styles.info__value}>{data.phone}</p>
                </div>
            </div>
            <div className={styles.card__actions}>
                <Link
                    to='#'
                    className={`${styles.actions__button} ${styles.actions__appointment}`}
                    onClick={onAppointmentReserve}
                >
                    Reservar hora
                </Link>

                {enableButtons ? (
                    <>
                        <Link
                            to={`${config.ROUTES.DASHBOARD.EXAMSPROCEDURES.HOME}?patient_id=${data.id}&from_family_group=true`}
                            className={`${styles.actions__button}`}
                        >
                            Ver exámenes
                        </Link>

                        <Link
                            to={`${config.ROUTES.DASHBOARD.MEDICALAPPOINTMENTS.HOME}/${data.id}?from_family_group=true&patient_id=${data.id}`}
                            className={`${styles.actions__button}`}
                        >
                            Ver historial médico
                        </Link>

                        <Link
                            to={`${config.ROUTES.DASHBOARD.BUDGETREQUEST}?patient_id=${data.id}&from_family_group=true`}
                            className={`${styles.actions__button}`}
                        >
                            Pedir presupuesto
                        </Link>
                    </>
                ) : (
                    <>
                        <span className={`${styles.actions__button} ${styles.disabled}`}>
                            Ver exámenes
                        </span>

                        <span className={`${styles.actions__button} ${styles.disabled}`}>
                            Ver historial médico
                        </span>

                        <span className={`${styles.actions__button} ${styles.disabled}`}>
                            Pedir presupuesto
                        </span>
                    </>
                )}



            </div>
        </div>
    )
}
